import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";


export const CourierCountryServiceDetails = () => {

    const history = useHistory()
    const [singleItem, setSingleItem] = useState()

    useEffect(() => {
        getDetails();
    },[])

    const getDetails = () => {
        const previousData = history.location.state
        setSingleItem(previousData)
        
    }    

    
  

  return (
    <div className="row d-flex justify-content-center">
    <div className="col-lg-6">
        <div className="card">
            <div className="card-body">
            
                    <div className="row justify-content-center">
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Servie Provider</label>
                            </div>
                            <div className="col-9">
                               <p>{singleItem && singleItem.service_provider}</p>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Zone</label>
                            </div>
                            <div className="col-9">
                            <p>{singleItem && singleItem.zone}</p>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Service Type</label>
                            </div>
                            <div className="col-9">
                            <p>{singleItem &&  singleItem.service_type}</p>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Countries</label>
                            </div>
                            <div className="col-9">
                            <ul className="CourierList">
                            {
                                singleItem &&  singleItem.countries.map((val, key)=>{
                                    return(
                                        <li>{val.country_name}</li>
                                    )
                                })
                            }
                            </ul>
                            </div>
                        </div>
                       
                    </div>

                    
                    <div className="mt-3 d-flex justify-content-between">
                        <button
                            className="btn btn-danger w-sm waves-effect waves-light"
                            type="button"
                            onClick={() => history.goBack()}
                        >Back</button>
                    </div>
            </div>
        </div>
    </div>
</div>
  );
};



{/* <div className="row">
                      
<div className="col-4">
    <div className="form-group">
            <label className="form-label" >Servie Provider</label>
            <p>{singleItem && singleItem.service_provider}</p>
    </div>
</div>

<div className="col-4">
    <div className="form-group">
            <label className="form-label" >Zone</label>
            <p>{singleItem && singleItem.zone}</p>
    </div>
</div>


<div className="col-4">
    <div className="form-group">
            <label className="form-label" >Servie Type</label>
            <p>{singleItem && singleItem.service_type}</p>
    </div>
</div>

<div className="col-12">
    <div className="form-group">
            <label className="form-label" >Servie Type</label>
            <ul className="list-group">
                {
                    singleItem && singleItem.countries.map((val, key)=>{
                        return(
                            <li className="list-group-item">{val.country_name}</li>
                        )
                    })
                }
                </ul> 
    </div>
</div>


</div> */}